import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import HttpRedirect from 'react-https-redirect'
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';


const root = ReactDOM.createRoot(document.getElementById('root'));
const rootElement = document.getElementById("root");



if (rootElement.hasChildNodes()) {
  ReactDOM.hydrateRoot(rootElement,
      <React.StrictMode>
        <HttpRedirect>
          <HelmetProvider>
            <App />
          </HelmetProvider>
        </HttpRedirect>
      </React.StrictMode>
  );
} else {
  root.render(
      <React.StrictMode>
        <HttpRedirect>
          <HelmetProvider>
            <App />
          </HelmetProvider>
        </HttpRedirect>
      </React.StrictMode>
  );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
